import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TitleWithSocialMediaComponent } from '@shared/title-with-social-media/title-with-social-media.component';
import { privacyPolicyTexts } from '@content/policy/privacy-policy/privacy-policy';
import { TextBlockWithSideBarComponent } from '@shared/text-block-with-side-bar/text-block-with-side-bar.component';

@Component({
    selector: 'companyid-privacy-policy',
    imports: [TitleWithSocialMediaComponent, TextBlockWithSideBarComponent],
    templateUrl: './privacy-policy.component.html',
    styleUrl: './privacy-policy.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivacyPolicyComponent {
    public readonly privacyPolicyTexts = privacyPolicyTexts;
}
